function Home() {
  return (
    <main>
      <div className="bg"></div>
      <section id="hero" className="flex justify-center align-center">
        <div className="inner">
          <h1>UC BRAIDS</h1>
          <h3>Professional Hair Braiding Services</h3>
          <div className="book-link">
            <a href="/" className="button button-primary">
              Book Now
            </a>
          </div>
        </div>
      </section>
      {/* <section id="popular">
        <div className="inner">
          <div className="row flex align-center justify-center">
            <div className="card flex column align-center justify-between">
              <div className="img">
                <img
                  src="https://res.cloudinary.com/qaz2dc/image/upload/v1692301340/ucbraids/styles/Small%20Knotless%20Box%20Braids/skbb1_uniqwk.jpg"
                  alt=""
                />
              </div>
              <div className="text flex column align-center justify-between">
                <h3>Marley Twist</h3>
                <p>
                  Discover the allure of Marley Twists – a versatile and
                  captivating hairstyle inspired by the iconic reggae legend.
                  Embrace natural elegance with these stunning twists, perfect
                  for all hair types and occasions.
                </p>
                <div className="book-link">
                  <a href="/" className="button button-primary2">
                    Book Now
                  </a>
                </div>
              </div>
            </div>
            <div className="card flex column align-center justify-between">
              <div className="img">
                <img
                  src="https://res.cloudinary.com/qaz2dc/image/upload/v1692368141/ucbraids/styles/Medium/Medium%20knotless%20Box%20Braids/mkbb1_yv34to.jpg"
                  alt=""
                />
              </div>
              <div className="text flex column align-center justify-between">
                <h3>Large Knotless Box Braids</h3>
                <p>
                  Discover the allure of Marley Twists – a versatile and
                  captivating hairstyle inspired by the iconic reggae legend.
                  Embrace natural elegance with these stunning twists, perfect
                  for all hair types and occasions.
                </p>
                <div className="book-link">
                  <a href="/" className="button button-primary2">
                    Book Now
                  </a>
                </div>
              </div>
            </div>
            <div className="card flex column align-center justify-between">
              <div className="img">
                <img
                  src="https://res.cloudinary.com/qaz2dc/image/upload/v1692378844/ucbraids/styles/kids/Kid%27s%20Braids/kb_kjxafw.jpg"
                  alt=""
                />
              </div>
              <div className="text flex column align-center justify-between">
                <h3>Marley Twist</h3>
                <p>
                  Discover the allure of Marley Twists – a versatile and
                  captivating hairstyle inspired by the iconic reggae legend.
                  Embrace natural elegance with these stunning twists, perfect
                  for all hair types and occasions.
                </p>
                <div className="book-link">
                  <a href="/" className="button button-primary2">
                    Book Now
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="link">
            <a href="/services">View all Styles</a>
          </div>
        </div>
      </section>
      <section id="cta">
        <div className="inner">
          <h2>What are you waiting for?</h2>
          <div className="book-link">
            <a href="/" className="button button-primary">
              Book Now
            </a>
          </div>
        </div>
      </section> */}
    </main>
  );
}

export default Home;
